import QuickviewTemplate from '../../../../../Template/theme/components/quickview/Quickview'
import MetricTable from './MetricTable'
import MetricDonut from './MetricDonut'
import MetricChart from './MetricChart'
import QuickviewCanvasContainer from './QuickviewCanvasContainer'

export default Object.assign(
  theme => QuickviewTemplate(theme),
  {
    ...QuickviewTemplate,
    QuickviewCanvasContainer,
    MetricTable,
    MetricDonut,
    MetricChart,
    Name: 'Category QSR Quickview'
  }
)



// WEBPACK FOOTER //
// ./src/app/configuration/TargetRetail/theme/components/quickview/Quickview/index.js